export { InfoModalWrapper, InfoModalWrapperProps } from './components/InfoModalWrapper';
